export default "__VITE_ASSET__DcH6VlA7__"